
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/console/company/chat/agreement_reports/create",
      function () {
        return require("private-next-pages/console/company/chat/agreement_reports/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/console/company/chat/agreement_reports/create"])
      });
    }
  